import {
    ElementTiptap,
    Doc,
    Text,
    Paragraph,
    Heading,
    Bold,
    Underline,
    Italic,
    ListItem,
    OrderedList,
    BulletList,
    TextAlign,
    Link,
    HardBreak,
    Blockquote,
    HorizontalRule,
    FormatClear
} from 'element-tiptap';

export default {
    components: {
        'el-tiptap': ElementTiptap,
    },
    props:      {
        links:       {
            type:     Array,
            required: false,
            default:  () => []
        },
        tags:        {
            type:     Array,
            required: false,
            default:  () => []
        },
        placeholder: {
            type:     String,
            required: false,
            default:  () => 'Kliknutím upravíte text...'
        }
    },
    data() {
        return {
            content:     null,
            showMenuBar: false,
        }
    },
    methods:    {
        prepareExtensions(extensions = []) {
            const headings = [];

            extensions.push(new Doc());
            extensions.push(new Text());
            extensions.push(new HardBreak());

            if (this.isAvailable('h1')) headings.push(1);
            if (this.isAvailable('h2')) headings.push(2);
            if (this.isAvailable('h3')) headings.push(3);
            if (this.isAvailable('h4')) headings.push(4);
            if (this.isAvailable('h5')) headings.push(5);
            if (this.isAvailable('h6')) headings.push(6);

            if (this.isAvailable('p')) extensions.push(new Paragraph({bubble: true}));
            if (headings.length) extensions.push(new Heading({level: headings, bubble: true}));
            if (this.isAvailable('strong')) extensions.push(new Bold({bubble: true}));
            if (this.isAvailable('quote')) extensions.push(new Blockquote({bubble: true}));
            if (this.isAvailable('underline')) extensions.push(new Underline({bubble: true}));
            if (this.isAvailable('italic')) extensions.push(new Italic({bubble: true}));
            if (this.isAvailable('hr')) extensions.push(new HorizontalRule({bubble: true}));
            if (this.isAvailable('list')) extensions.push(new ListItem({bubble: true}));
            if (this.isAvailable('list')) extensions.push(new BulletList({bubble: true}));
            if (this.isAvailable('list')) extensions.push(new OrderedList({bubble: true}));
            if (this.isAvailable('a')) extensions.push(new Link({bubble: true}));
            if (this.isAvailable('text-align')) extensions.push(new TextAlign({bubble: true}));
            if (this.isAvailable('blockquote')) extensions.push(new Blockquote({bubble: true}));
            if (this.isAvailable('clear')) extensions.push(new FormatClear({bubble: true}));

            return extensions;
        },
        isAvailable(tag) {
            return this.tags.length === 0 || this.tags.indexOf(tag) !== -1;
        },
        setContent(value) {
            this.content = value;
        },
        onFocus() {
            this.showMenuBar = true;
        },
        onBlur() {
            this.showMenuBar = false;
            this.$emit('change', this.content);
            this.$emit('blur');
        }
    }
}
